module.exports = __webpack_public_path__ + "img/Oman.92a4f5bf.svg";